// 정책 ---------------------------------------------------------

/**
 * 아동 삭제 동의 전문
 */
export const CHILD_DELETE_KEY = "malirang_child_delete.txt";

/**
 * 센터 삭제
 */
export const CENTER_DELETE_KEY = "malirang_center_delete.txt";

/**
 * 대표 권한 위임
 */
export const CENTER_DELEGATE_KEY = "malirang_center_delegate.txt";

/**
 * 주 보호자 변경
 */
export const CHANGE_GUARDIAN_KEY = "malirang_change_guardian.txt";

/**
 * 구성원 활동중지
 */
export const CENTER_USER_STOP_KEY = "malirang_center_user_stop.txt";

/**
 * 센터 탈퇴
 */
export const EXIT_CENTER_KEY = "malirang_exit_center.txt";

/**
 * 센터 유저 삭제
 */
export const DELETE_CENTER_USER_KEY = "malirang_delete_center_user.txt";

/**
 * 선생님 회원탈퇴
 */
export const USER_WITHDRAW_KEY = "malirang_user_withdraw.txt";

/**
 * 부모님 회원탈퇴
 */
export const PARENT_WITHDRAW_KEY = "malirang_parent_withdraw.txt";

/**
 * LP조음검사 이용전문
 */
export const LP_KEY = "malirang_lp.txt";

// 약관 ---------------------------------------------------------

/**
 * 개인정보취급방침 키
 */
export const PRIVACY_KEY = "malirang_privacy.txt";

/**
 * 이용약관 키
 */
export const USE_KEY = "malirang_use.txt";

/**
 * 마케팅 약관 키
 */
export const MARKETING_KEY = "malirang_marketing.txt";

/**
 * EULA
 */
export const EULA_KEY = "malirang_eula.txt";

// ---------------------------------------------------------

/**
 * company-info 키
 */
export const COMPANY_INFO_KEY = "malirang_company_info.json";

/**
 * 컨테이너 키
 */
export const INFO_CONTAINER = "info";

/**
 * 컨테이너 키
 */
export const STORE_MENU_KEY = "malirang_store_menu.json";
